import { gql } from 'apollo-boost';

const SEND_APP_LINKS = gql`
  mutation sendCustomerLinks($customerId: Int!) {
    sendCustomerLinks(customerId: $customerId)
  }
`;

export default SEND_APP_LINKS;
